import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import Top from '@/pages/top/vue/Top'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Index,
      children: [
        {
          path: '',
          name: 'Top',
          component: Top
        }
      ]
    },
    {
      path: '/share/spot',
      component: Index,
      children: [
        {
          path: '',
          name: 'Top',
          component: Top
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js